import { Component, OnInit } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../environments/environment";
import { ActualSelected } from "../../../shared/utils";

@Component({
  selector: "convfact-model182",
  templateUrl: "./model-182.component.html",
  standalone: false
})
export class Model182Component implements OnInit {
  title = "Modelo 182 - Seguimiento de donativos (cuotas de asociados y donaciones)";
  rows: any[] = [];
  isLoading = false;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.getData();
  }

  async getData(): Promise<void> {
    this.isLoading = true;

    const params = new HttpParams().set("year", ActualSelected.yearSelected);

    try {
      const response: any = await firstValueFrom(
        this.http.get(`${environment.apiUrl}/model-taxes/182`, { params: params })
      );
      this.rows = (response && response.data) ? response.data : [];
    } catch {
      this.rows = [];
    } finally {
      this.isLoading = false;
    }
  }

  tipoLabel(tipoIngreso: string): string {
    return tipoIngreso === "720" ? "Cuota de socio" : "Donación";
  }
}
